
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import HListSection from "components/Architects/Sections/HListSection";
import IconsLinksSection from "components/Architects/Sections/IconsLinksSection";
import JurySection from "components/Architects/Sections/JurySection";
import LinkSection from "components/Architects/Sections/LinkSection";
import OListSection from "components/Architects/Sections/OListSection";
import Plaintext from "components/Architects/Sections/PlainTextSection";
import TimelineSection from "components/Architects/Sections/TimelineSection";
import TitleDesc from "components/Architects/Sections/TitleDescSection";
import { architectsSections, content, jury, } from "constants/architectsTranslation";
import ArchitectsLayout from "layout/ArchitectsLayout";
function Architects() {
    return (<div>
      {architectsSections.map((section, index) => {
            if (section.isTimeline) {
                return (<div key={index} className="mb-5" id={section.label}>
              <h3>{section.label}</h3>
              <div className="px-3">
                {/* @ts-ignore */}
                <TimelineSection data={...section.content}/>
                <div className="text-center mt-3">{section?.deadline}</div>
              </div>
            </div>);
            }
            const subsectionComps = section.content.map((item) => {
                return ItemGenerator(item);
            });
            return (<div key={index} className="mb-5" id={section.label}>
            <h3>{section.label}</h3>
            <div className="ps-3">{subsectionComps}</div>
          </div>);
        })}
      <JurySection jury={jury}/>
    </div>);
}
export default Architects;
Architects.Layout = ArchitectsLayout;
const ItemGenerator = (item: content) => {
    switch (item.type) {
        case "h-list":
            return <HListSection {...item}/>;
        case "iconsWithLinks":
            return <IconsLinksSection {...item}/>;
        case "link":
            return <LinkSection {...item}/>;
        case "o-list":
            return <OListSection {...item}/>;
        case "plain":
            return <Plaintext {...item}/>;
        case "titleDesc":
            return <TitleDesc {...item}/>;
        default:
            return null;
    }
};

    async function __Next_Translate__getStaticProps__1a13f66be18__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/architects-for-azaz/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66be18__ as getStaticProps }
  